.MultiSelectEditor {
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	flex: 1;
	grid-gap: 10px;
}
.MultiSelectEditor__option {
	display: inline-block;
	padding: 5px 5px 5px 10px;
	font-size: 16px;
	font-weight: var(--semibold);
	line-height: 20px;
	height: 30px;
	box-sizing: border-box;
	border-radius: 8px;
	border: 1px solid var(--gray1);
	background: transparent;
	cursor: pointer;
	user-select: none;
}
.MultiSelectEditor__option:hover {
	background: var(--gray2);
}
.MultiSelectEditor__option--is-selected,
.MultiSelectEditor__option--is-selected:hover {
	background: var(--green-light);
	border-color: transparent;
}
.MultiSelectEditor__option:after {
	content: '';
	display: inline-block;
	width: 1em;
	height: 1em;
	background-image: url('~/src/icons/plus.svg');
	background-repeat: no-repeat;
	background-position: center center;
	background-size: 100% auto;
	vertical-align: middle;
	margin-left: 0.5em;
	margin-right: 0.25em;
	margin-top: -1px;
}
.MultiSelectEditor__option--is-selected:after {
	background-image: url('~/src/icons/check.svg');
	animation: force-checkmark 0.75s steps(2) backwards;
}
.MultiSelectEditor__option--is-selected:hover:after {
	background-image: url('~/src/icons/minus.svg');
}
.MultiSelectEditor__optionCheckbox {
	display: none;
}
@keyframes force-checkmark {
	0%, 99% {
		background-image: url('~/src/icons/check.svg');
	}
}